export default "__VITE_ASSET__hYkFQbuL__"